import { Component, OnInit, OnDestroy, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AppConstants } from 'appshared/app-constants';
import * as Models from 'appshared/shared-models';
import { TextTools } from 'appshared/text-tools';
import { MiscTools } from 'appshared/misc-tools';
import { UITools } from 'appshared/ui-tools';

import { AuthService } from 'client/app/services/auth.service';

@Component({
	selector: 'app-card-document',
	templateUrl: './card-document.component.html',
	styleUrls: ['./card-document.component.scss']
})
export class CardDocumentComponent implements OnInit {
	@Input() parentApi !: any;
	@Input() object: Models.Document = null;
	@Input() options: any = {};

	ac = AppConstants;
	tt = TextTools;
	mt = TextTools;

	now = new Date();

	debug: boolean = false;
	debugTime = new Date();
	loading: boolean = false;
	working: boolean = false;
	authUser: Models.AuthUser = null;

	objectToShow: Models.Document = null;

	// options


	nameToShow: string = '[name]';
	typeToShow: string = '[type]';
	iconToShow: any = null;
	infoLines: string[] = [];
	extraLines: string[] = [];


	// ------------------------------------------------------------------------
	constructor(
		private router: Router,
		private authService: AuthService) {

		// this.router.routeReuseStrategy.shouldReuseRoute = function () {
		// 	return false;
		// };
	} // 

	// ------------------------------------------------------------------------
	ngOnInit(): void {
		const sessionUser: Models.AuthUser = this.authService.getUser();
		if (sessionUser != null && sessionUser.id !== 0) {
			this.authUser = sessionUser;
			this.setups();
		} // if
	}

	// ------------------------------------------------------------------------
	async setups() {
		this.loading = true;

		let optionKeys: string[] = [];
		if (this.options) optionKeys = Object.keys(this.options);

		// if (optionKeys.includes('includeClickInfo')) this.includeClickInfo = this.options.includeClickInfo;
		// if (optionKeys.includes('extraStyles')) this.extraStyles = this.options.extraStyles;
		// if (optionKeys.includes('extraClasses')) this.extraClasses = this.options.extraClasses;
		// if (optionKeys.includes('dark')) this.dark = this.options.dark;
		// if (optionKeys.includes('superscriptLevels')) this.superscriptLevels = this.options.superscriptLevels;

		this.setObject(this.object);
	}

	// ------------------------------------------------------------------------
	async setObject(object: Models.Document) {

		this.objectToShow = MiscTools.deepClone(object);

		if (!this.objectToShow) return;

		this.nameToShow = this.objectToShow.label;
		this.typeToShow = 'Document';
		this.iconToShow = AppConstants.sectionIcons.organizations;

		this.infoLines = [];

		if (this.objectToShow.prod_name && this.objectToShow.prod_name !== '') this.infoLines.push('Product: ' + this.objectToShow.prod_name);
		if (this.objectToShow.label && this.objectToShow.label !== '') this.infoLines.push('Label: ' + this.objectToShow.label);
		if (this.objectToShow.last_download) this.infoLines.push('Last Download: ' + TextTools.formatDateNiceUTC(this.objectToShow.last_download));
		this.infoLines.push('Added: ' + TextTools.formatDateNiceUTC(this.objectToShow.added_on));
		if (this.objectToShow.edited_on && this.objectToShow.edited_on !== this.objectToShow.added_on) this.infoLines.push('Edited: ' + TextTools.formatDateNiceUTC(this.objectToShow.edited_on));

		this.extraLines = [];
	} //


	// ------------------------------------------------------------------------
	debugMessage(theMsg: string) {
		if (this.debug) {
			const now = new Date();
			const ms = now.getTime() - this.debugTime.getTime();
			console.log('con.primt.card ' + ms.toLocaleString() + ' - ' + theMsg);
		}
	} // debugMessage}

}
